module.exports = __webpack_public_path__ + "media/images/personalized-demo-1b69da5d.png";